@if (isVisible) {
  <div
    class="cutoff-timer-preview-outer"
    [class.cutoff-timer-preview-outer--center]="textAlignment === 'center'"
    [class.cutoff-timer-preview-outer--right]="textAlignment === 'right'"
    [class.cutoff-timer-preview-outer--justify]="textAlignment === 'justify'">
    <div class="cutoff-timer-preview" [class.cutoff-timer-preview--has-bg]="hasBackground" [ngStyle]="backgroundStyle">
      @if (iconSrc) {
        <img class="cutoff-timer-preview__icon" [src]="iconSrc" alt="" />
      }
      <span class="cutoff-timer-preview__text" [innerHTML]="renderedHtml | safe"></span>
    </div>
  </div>
}
